/* eslint-disable spire/export-styles */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import styled, { css } from "styled-components";

const enum fields {
    background = "background",
    image = "image",
    backgroundColor = "backgroundColor",
    heading = "heading",
    description = "description",
    link = "link",
    buttonTitle = "buttonTitle",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.background]: "image" | "color";
        [fields.image]: string;
        [fields.backgroundColor]: string;
        [fields.heading]: string;
        [fields.description]: string;
        [fields.link]: LinkFieldValue;
        [fields.buttonTitle]: string;
    };
}

export interface CurrentOpeningStyles {
    contentContainer?: InjectableCss;
    linKContainer?: InjectableCss;
    title?: TypographyProps;
    desc?: TypographyProps;
    linkStyle?: LinkPresentationProps;
}

export const CurrentOpeningStyles: CurrentOpeningStyles = {
    contentContainer: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 100%;
                        `,
                        css`
                            width: 100%;
                        `,
                        css`
                            width: 100%;
                        `,
                        css`
                            /* width: 65%; */
                            width: 60%;
                            padding-left: 45px;
                            position: relative;
                            left: 62px;
                            bottom: 45px;
                        `,
                        css`
                            /* width: 65%; */
                            width: 60%;
                            padding-left: 45px;
                            position: relative;
                            left: 62px;
                            bottom: 45px;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    linKContainer: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 100%;
                            justify-content: flex-start;
                        `,
                        css`
                            width: 100%;
                            justify-content: flex-start;
                        `,
                        css`
                            width: 100%;
                            justify-content: flex-start;
                        `,
                        css`
                            width: 35%;
                            justify-content: center;
                            display: inline;
                        `,
                        css`
                            width: 35%;
                            justify-content: center;
                            display: inline;
                        `,
                    ],
                    "min",
                )}
            display: flex;
            justify-content: center;
        `,
    },
    title: {
        variant: "h3",
        css: css`
            color: #fff;
            text-transform: uppercase;
            font-size: 2.25rem;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            line-height: 36px;
                            margin-bottom: 10px;
                        `,
                        null,
                        css`
                            margin-bottom: 20px;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    desc: {
        variant: "p",
        css: css`
            color: #fff;
            font-size: 1rem;
            line-height: 24px;
        `,
    },
    linkStyle: {
        css: css`
            /* border: 2px solid #fff;
            padding: 5px 30px;
            background-color: transparent;
            text-transform: uppercase; */
            display: inline-block;
            background: #fff; 
            text-transform: uppercase;
            font-weight: bold;
            font-size: 18px; 
            padding-top: 0.6rem;
            padding-right: 2rem;
            padding-bottom: 0.65rem;
            padding-left: 2rem; 
            margin: 0 0 1.25rem;
            text-decoration: none;
            &:hover{
                    background: #222 !important;
                    span{
                        color: #fff !important;
                    }
                }
            span {
                color: #222 !important;
               
            }
        `,
    },
};

type Props = OwnProps;

const styles = CurrentOpeningStyles;

const CustomTitleWrapper = styled.div<{
    backgroundImage: string;
    backgroundColor: string;
    checkBackground: string;
}>`
    background: ${props =>
        props.checkBackground === "image" ? `url(${props.backgroundImage})` : props.backgroundColor};
    background-size: cover;
    display: flex;
    align-items: center;
    margin: 0px auto 50px;
    flex-wrap: wrap;
    margin-top:60px;
    ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(
            theme,
            [
                css`
                    max-width: 100% !important;
                    padding: 40px;
                `,
                css`
                    max-width: 100% !important;
                    padding: 40px;
                `,
                css`
                    max-width: 720px !important;
                    padding: 40px;
                `,
                css`
                    max-width: 960px !important;
                    padding: 40px;
                    background-position: center;
                    height: 410px;
                `,
                css`
                    max-width: 960px !important;
                    padding: 50px;
                    background-position: center;
                    height: 410px;
                `,
            ],
            "min",
        )};
`;

const CurrentOpenings: React.FunctionComponent<Props> = ({ fields }: Props) => {
    const { url } = useGetLink(fields.link);
    return (
        <StyledWrapper>
            <CustomTitleWrapper
                backgroundImage={fields.image}
                backgroundColor={fields.backgroundColor}
                checkBackground={fields.background}
            >
                <StyledWrapper {...styles.contentContainer}>
                    <Typography {...styles.title}>{fields.heading}</Typography>
                    <Typography {...styles.desc}>{fields.description}</Typography>
                    <StyledWrapper {...styles.linKContainer}>
                        <Link href={url} {...styles.linkStyle}>
                            {fields.buttonTitle}
                        </Link>
                    </StyledWrapper>
                </StyledWrapper>

                {/* <StyledWrapper {...styles.linKContainer}>
                    <Link href={url} {...styles.linkStyle}>
                        {fields.buttonTitle}
                    </Link>
                </StyledWrapper> */}
            </CustomTitleWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: CurrentOpenings,
    definition: {
        group: "Basic",
        icon: "heading",
        fieldDefinitions: [
            {
                fieldType: "Translatable",
                name: fields.heading,
                editorTemplate: "TextField",
                displayName: "Title",
                defaultValue: "",
                sortOrder: 0,
            },
            {
                fieldType: "General",
                name: fields.background,
                displayName: "Background",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Image", value: "image" },
                    { displayName: "Color", value: "color" },
                ],
                defaultValue: "image",
                hideEmptyOption: true,
                sortOrder: 1,
            },
            {
                fieldType: "Translatable",
                name: fields.image,
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                isVisible: widget => widget.fields.background === "image",
                sortOrder: 2,
            },
            {
                fieldType: "General",
                name: fields.backgroundColor,
                editorTemplate: "ColorPickerField",
                displayName: "Color",
                defaultValue: "black",
                isVisible: widget => widget.fields.background === "color",
                sortOrder: 3,
            },

            {
                fieldType: "Translatable",
                name: fields.description,
                displayName: "Description",
                editorTemplate: "MultilineTextField",
                defaultValue: "",
                sortOrder: 4,
            },
            {
                name: fields.link,
                fieldType: "General",
                displayName: "Link",
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
                // allowUrls: item => false,
                // allowCategories: item => false,
                sortOrder: 5,
            },
            {
                fieldType: "Translatable",
                name: fields.buttonTitle,
                editorTemplate: "TextField",
                displayName: "Button Title",
                defaultValue: "",
                sortOrder: 3,
            },
        ],
    },
};

export default widgetModule;
